<template>
  <div id="exploration">

    <Navbar></Navbar>

    <!-- LIST VIEW -->
    <div v-if="mode == 'list'" class="list-view">
      <div class="exploration-header">
        <!-- EXPLORATION TITLE -->
        <div class="exploration-title clickable" @click="mode = 'list'">{{ exploration.title }}</div>
      </div><!-- /.exploration-header -->
      <div class="container">
        <button @click="viewMap()" class="btn btn-outline-primary m-2"><i class="fal fa-map-marked"></i> Map View</button>
        <div v-for="point in exploration.points" @click="showPoint(point)" class="card mt-2 ml-2 clickable">
          <div v-if="point.images[0]">
            <img :src="point.images[0].medium" class="card-img-top">
          </div><!-- /. v-if -->
          <div class="card-body">
            {{ point.title }}
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div><!-- /.container -->
    </div><!-- /.list-view -->

    <!-- POINT VIEW -->
    <ExplorationPoint v-if="mode == 'point'" :exploration="exploration" :point="point"></ExplorationPoint>

    <!-- MAP VIEW -->
    <ExplorationMap v-if="mode == 'map'" :exploration="exploration"></ExplorationMap>
  </div>
</template>

<script>
  const fb = require('../firebaseConfig.js')
  import moment from 'moment'
  import Navbar from './Navbar.vue'
  import ExplorationMap from './ExplorationMap.vue'
  import ExplorationPoint from './ExplorationPoint.vue'

  export default {
    data() {
      return {
        exploration: {},
        point: {},
        mode: this.$route.params.mode
      }
    },
    components: {
      Navbar,
      ExplorationMap,
      ExplorationPoint
    },
    created() {
      this.getExploration(this.$route.params.id)
    },
    watch: {
      '$route.params.mode': function (mode) {
        this.mode = mode
      }
    },
    methods: {
      viewMap() {
        this.$router.replace({params: {mode: 'map'}})
      },
      showPoint(point) {
        this.point = point
        this.$router.replace({params: {mode: 'point', slug: point.slug}})
      },
      getExploration(id) {
        fb.explorationsCollection.doc(id).onSnapshot(doc => {
          let exploration = doc.data()
          exploration.id = doc.id
          this.exploration = exploration
          // Check for a point slug
          let slug = this.$route.params.slug
          if (slug) {
            // Loop through points looking for this slug
            for (let i = 0; i < exploration.points.length; i++) {
              // Check for a match
              if (slug == exploration.points[i].slug) {
                // Assign the matching point
                this.point = this.exploration.points[i]
              }
            }
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Exploration.vue